// extracted by mini-css-extract-plugin
var _1 = "SwapMyBoxModal_disclaimer__4OgM5";
var _2 = "SwapMyBoxModal_doNotCancel__xfOaE";
var _3 = "SwapMyBoxModal_mainText__0J3pm";
var _4 = "768px";
var _5 = "SwapMyBoxModal_noThanks__b3N9H";
var _6 = "'../../../../shared.module.css'";
var _7 = "SwapMyBoxModal_swapYourBox__SBOM2";
var _8 = "SwapMyBoxModal_textContent__Bwsg6";
var _9 = "SwapMyBoxModal_yesLearnMore__UVq1n";
export { _1 as "disclaimer", _2 as "doNotCancel", _3 as "mainText", _4 as "md", _5 as "noThanks", _6 as "shared", _7 as "swapYourBox", _8 as "textContent", _9 as "yesLearnMore" }
